export class TdoColorPickerEvent {
  hex: string;
}
